// extracted by mini-css-extract-plugin
module.exports = {"toc":"TableOfContents--toc--3BKCb","title":"TableOfContents--title--2WpOT","tableOfContentsWrapper":"TableOfContents--tableOfContentsWrapper--1_jNA"};